import React, { Component } from "react";
import axios from 'axios';
import Config from '../config.js';
import { Card, Grid, Typography, CardContent, ButtonBase, IconButton } from '@material-ui/core';
import { Link } from 'react-router-dom';
import ErrorIcon from '@material-ui/icons/Error';
import {EmbeddedOnboarding as SupplierOnboarding} from "../ccn/supplier_onboarding.js";
import {Alert} from "@material-ui/lab";
import Reports from '../reports/reports.js';
import ContentLoader from '../general/content_loader.js';
import moment from "moment";
import DownloadButton from "../general/download_button.js";
import Auth from '../auth.js';
import CloseIcon from '@material-ui/icons/Close';
import EventModal from '../messages/event_modal.js';

class FinancingBanner extends Component {
    state = {loading: true, availableToFinance: 0};
    async componentDidMount(){
        let gmv = (await axios.get(Config.api + `/odata/company/VwActivityHistoryByDay?$select=Attribute2&$filter=(DocumentType eq 'Order') and (ActivityDateTime gt ${moment().add(-30, 'days').toISOString()})`)).data.value;
        let sum = gmv.map(r => r.Attribute2).reduce((a, b) => a + b, 0);
        this.setState({loading: false, availableToFinance: sum});
    }
    formatCurrency(amount, currency){
        return Intl.NumberFormat('en-US', {
          style: 'currency',
          currency: currency || 'USD',
          maximumFractionDigits: 0
      }).format(amount);
    }
    async getFinancing(){
        let connectToken = (await axios.post(Config.api + "/api/v2/financing/connect")).data.Body;
        window.KANMON_CONNECT.start({connectToken});
        window.KANMON_CONNECT.show();
    }
    getActionText(status){
        if(!status){
            return 'Get financing';
        } else if (status === 'ONBOARDED'){
            return 'View application';
        } else if (status === 'OFFERED'){
            return 'View offers';
        }
        return 'Finish financing application';
    }
    getSubText(status){
        if(status === 'OFFERED'){
            return 'Finance orders from the Orders page';
        }
        return this.formatCurrency(this.state.availableToFinance) + ' available for financing'
    }
    render() {
        if(this.state.loading){
            return <ContentLoader preserveAspectRatio='none' style={{height: '6em', width: '100%'}} primaryColor='#e1e1e1' secondaryColor='#d8d8d8'/>;
        }
        return <Grid item lg={12} md={12} sm={12} xs={12}>
            <Card style={{backgroundColor: '#EDF7FD'}}>
                <CardContent style={{display: 'flex', alignItems: 'baseline', flexDirection: 'row'}}>
                    <div style={{flex: 1, textAlign: 'left'}}>
                        <Typography variant="h6">Need financing, {this.props.companyName}?</Typography>
                        <Typography>Get a small business loan from us today!</Typography>
                    </div>
                    <div>
                        <DownloadButton style={{width: '18em'}} color='primary' variant='contained' onClick={this.getFinancing}>{this.getActionText(this.props.financialStatus)}</DownloadButton>
                        <Typography style={{color: '#006BFF', fontWeight: 'bold', fontSize: '12px', marginTop: '0.25em'}}>{this.getSubText(this.props.financialStatus)}</Typography>
                    </div>
                    
                </CardContent>
            </Card>
    </Grid>;
    }
}

class Dashboard extends Component {
    state = {};
    async componentDidMount() {
        await this.load();
    }
    async load(){
        let urgentMessages = (await axios.get(Config.api + '/odata/Company/VwCompanyPosts?$filter=RequireAck eq true and Acknowledged eq false and Sender ne Receiver&$count=true&$top=0')).data["@odata.count"];
        let bannerEvents = (await axios.get(Config.api + '/odata/Company/VwActivityEvents?$filter=EventTypeId eq 56 and Viewed eq false and Category eq \'Portal\' and EventLevel eq \'Alert\'&$orderby=Id desc&$top=1')).data.value;
        let profileIncomplete = false;
        if(!this.props.isRetailer){
            let profile = ((await axios.get(Config.api + "/odata/Company/CompanyProfiles")).data.value || [])[0];
            profileIncomplete = profile && !profile.Description && profile.Discoverable !== false && (profile.MerchFirstName || profile.MerchLastName || profile.MerchEmail || profile.Website);
        }
        this.setState({urgentMessages: urgentMessages, profileIncomplete: !(!profileIncomplete), bannerEvent: bannerEvents[0]});
    }
    async dismissEvent(){
        await axios.get(Config.api+'/odata/Company/Functions.MarkEvents?viewed=true&ids='+this.state.bannerEvent.Id);
        await this.load();
    }
  render() {
    return (
        <Grid container spacing={2}>
        {this.state.urgentMessages ?
            <Grid item lg={12} md={12} sm={12} xs={12}>
                <Link style={{color: 'white', fontSize: '16px'}} to='/message-center?q.0=RequireAck%20eq%20true&q.1=Acknowledged%20eq%20false'>
                    <Card id="cueMessage" style={{backgroundColor: '#ee3224', color: 'white'}}>
                        <CardContent style={{display: 'flex', alignItems: 'center'}}>
                                <ErrorIcon style={{marginRight: '1rem'}}/><div style={{display: 'inline-block'}}>There {this.state.urgentMessages === 1 ? 'is' : 'are'} {this.state.urgentMessages === 1 ? 'one' : this.state.urgentMessages} message{this.state.urgentMessages === 1 ? '' : 's'} that require{this.state.urgentMessages === 1 ? 's' : ''} action. Click here to go to the message center.</div>
                        </CardContent>
                    </Card>
                </Link>
            </Grid>
             : ''}
        {!(!this.state.bannerEvent) ?
            <Grid item lg={12} md={12} sm={12} xs={12} style={{position: 'relative'}}>
                <ButtonBase style={{color: 'white', fontSize: '16px', width: '100%', display: 'flex'}} onClick={async () => {await this.setState({eventId: null}); await this.setState({eventId: this.state.bannerEvent.Id});}}>
                    <Card id="cueBannerEvent" style={{backgroundColor: '#ee3224', color: 'white', flex: 1}}>
                        <CardContent style={{display: 'flex', alignItems: 'center'}}>
                                <ErrorIcon style={{marginRight: '1rem'}}/>
                                <div style={{display: 'inline-block', flex: 1, textAlign: 'left'}}><span style={{fontWeight: 'bold'}}>Most recent event:</span> {this.state.bannerEvent.Summary} Click to see details.</div>
                        </CardContent>
                    </Card>
                </ButtonBase>
                <IconButton style={{color: "white", padding: 0, position: 'absolute', right: '24px', top: '24px'}} onClick={() => this.dismissEvent()}>
                    <CloseIcon/>
                </IconButton>
                </Grid>
             : ''}
        {this.state.profileIncomplete ?
            <Grid item lg={12} md={12} sm={12} xs={12} style={{display: 'flex'}}>
                <Link style={{flex: '1'}} to='/profile/account-information'>
                    <Card style={{flex: 1}}>
                        <Alert severity="info">
                            <Typography style={{textAlign: 'left'}}>Click here to complete your company profile. Unlock partnership opportunities, share your products with potential partners and allow partners to discover your company-specific details for easier order fulfillment through our Connected Commerce Network.</Typography>
                        </Alert>
                    </Card>
                </Link>
            </Grid>
        : ''}
        {this.props.financingEnabled && this.props.financialStatus !== "ACCEPTED" && Auth.hasPermission("settings/manage") && <FinancingBanner financialStatus={this.props.financialStatus} companyName={this.props.companyName}/>}
        {!this.props.isRetailer ? <SupplierOnboarding/> : ''}
        <Reports isRetailer={this.props.isRetailer} companyName={this.props.companyName} cols={{lg: 12, md: 8, sm: 6, xs: 4, xxs: 2}}/>
        <EventModal eventId={this.state.eventId} viewed={true}/>
        </Grid>

    );
  }
}

export default Dashboard;
